import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import uniqid from 'uniqid';
import Swal from 'sweetalert2';
import { Container, Grid, TextField } from '@mui/material';
import { getCollectionsComplete, updateData, getDate } from '../../assets/js/functions';
import logo from '../../assets/images/header/Logo.svg';
import puntero from '../../assets/images/inicio/puntero.png';
import diploma from '../../assets/images/aprobo/Certificado.png';
import creaDiplomaPDF from '../../assets/js/diploma';
import './styles.scss';
import { reporteUsuarios } from '../../assets/js/reportes';

export default function Inicio() {
  const [mx, setMx] = useState('');
  const [usuario, setUsuario] = useState({});

  const verificarUsuario = async (e) => {
    const datosUsuario = await getCollectionsComplete(`${process.env.REACT_APP_BD_USUARIOS}/${mx}`);
    console.log(datosUsuario);
    console.log(mx);
    if (mx === '') {
      Swal.fire({
        title: '¡Espera!',
        text: 'Ingresa tu número MX para poder continuar.',
        icon: 'warning',
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#0033a0',
      });
      return null;
    }

    if (typeof datosUsuario === 'object' && Object.keys(datosUsuario).length > 0) {
      creaDiplomaPDF(datosUsuario.nombre, diploma);
    } else {
      Swal.fire({
        title: '¡Espera!',
        text: 'El número MX ingresado no existe.',
        icon: 'warning',
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#0033a0',
      });
    }

    sessionStorage.setItem('mx', mx);
  };

  return (
    <>
      <div id='inicio'>
        <div className='header'>
          <img src={logo} alt='logo' />
        </div>
        <Container maxWidth='md'>
          <Grid container justifyContent='center' alignItems='center' spacing={4}>
            <Grid item xs={12} sm={12} md={9} lg={9} data-aos='zoom-in' data-aos-delay='0' data-aos-duration='1000'>
              <h1>¡Enhorabuena!</h1>
              <h2>
                Has llegado a la recta final del
                <br /> programa.
              </h2>
              <p>Muchas gracias por tu compromiso y esfuerzo, te invitamos a seguir aplicando las técnicas y herramientas que trabajamos durante este curso.</p>
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={9}>
              <div className='container'>
                <h2 className='azul'>Para obtener tu reconocimento ingresa tu MX.</h2>
                <h1 className='azul'>¡Mucho éxito!</h1>
                <TextField label='MX' variant='filled' fullWidth value={mx} onChange={(e) => setMx(e.target.value)} />
                <div className='iniciar'>
                  <img src={puntero} alt='img' className='puntero' />
                  <div className='btn-iniciar' onClick={() => verificarUsuario()}>
                    Descarga tu reconocimiento
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}
